var _circle, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTopCalenderIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_28_3",
    "data-name": "Component 28 \\u2013 3",
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_60",
    "data-name": "Ellipse 60",
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#fff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "calendar_3_",
    "data-name": "calendar (3)",
    transform: "translate(7 -23)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_480",
    "data-name": "Path 480",
    d: "M17.473,32.055H15.855v-.527a.527.527,0,1,0-1.055,0v.527H11.637v-.527a.527.527,0,1,0-1.055,0v.527H7.418v-.527a.527.527,0,1,0-1.055,0v.527H3.2v-.527a.527.527,0,1,0-1.055,0v.527H.527A.527.527,0,0,0,0,32.582V46.293a.527.527,0,0,0,.527.527H17.473A.527.527,0,0,0,18,46.293V32.582A.527.527,0,0,0,17.473,32.055Zm-.527,13.711H1.055V36.273H16.945Zm0-10.547H1.055V33.109h1.09v.527a.527.527,0,0,0,1.055,0v-.527H6.363v.527a.527.527,0,0,0,1.055,0v-.527h3.164v.527a.527.527,0,0,0,1.055,0v-.527H14.8v.527a.527.527,0,0,0,1.055,0v-.527h1.09Z",
    transform: "translate(0 0)",
    fill: "#041543"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_481",
    "data-name": "Path 481",
    d: "M62.209,214.01a.527.527,0,0,0,.746,0l2.109-2.109a.527.527,0,0,0-.746-.746l-1.736,1.736-.682-.682a.527.527,0,0,0-.746.746Z",
    transform: "translate(-58.855 -173.672)",
    fill: "#041543"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_482",
    "data-name": "Path 482",
    d: "M62.209,334.01a.527.527,0,0,0,.746,0l2.109-2.109a.527.527,0,0,0-.746-.746l-1.736,1.736-.682-.682a.527.527,0,1,0-.746.746Z",
    transform: "translate(-58.855 -289.454)",
    fill: "#041543"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_483",
    "data-name": "Path 483",
    d: "M197.209,214.01a.527.527,0,0,0,.746,0l2.109-2.109a.527.527,0,1,0-.746-.746l-1.736,1.736-.682-.682a.527.527,0,0,0-.746.746Z",
    transform: "translate(-189.109 -173.672)",
    fill: "#041543"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_484",
    "data-name": "Path 484",
    d: "M332.209,214.01a.527.527,0,0,0,.746,0l2.109-2.109a.527.527,0,0,0-.746-.746l-1.736,1.736-.682-.682a.527.527,0,0,0-.746.746Z",
    transform: "translate(-319.363 -173.672)",
    fill: "#041543"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_485",
    "data-name": "Path 485",
    d: "M213.637,361h-2.109a.527.527,0,0,0,0,1.055h2.109a.527.527,0,0,0,0-1.055Z",
    transform: "translate(-203.582 -318.398)",
    fill: "#041543"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_486",
    "data-name": "Path 486",
    d: "M348.637,361h-2.109a.527.527,0,0,0,0,1.055h2.109a.527.527,0,0,0,0-1.055Z",
    transform: "translate(-333.836 -318.398)",
    fill: "#041543"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopCalenderIcon);
export default __webpack_public_path__ + "static/media/top-calender-icon.c49a9224de1bd9133922c1cea3a2ca0e.svg";
export { ForwardRef as ReactComponent };